var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.469 0H3.17436C1.60293 0 0.326141 1.29464 0.326141 2.88393V37.1161C0.326141 38.7054 1.60293 40 3.17436 40H37.469C39.0404 40 40.3261 38.7054 40.3261 37.1161V2.88393C40.3261 1.29464 39.0404 0 37.469 0ZM12.4154 34.2857H6.48686V15.1964H12.4244V34.2857H12.4154ZM9.45114 12.5893C7.54936 12.5893 6.01364 11.0446 6.01364 9.15179C6.01364 7.25893 7.54936 5.71429 9.45114 5.71429C11.344 5.71429 12.8886 7.25893 12.8886 9.15179C12.8886 11.0536 11.3529 12.5893 9.45114 12.5893V12.5893ZM34.6386 34.2857H28.7101V25C28.7101 22.7857 28.6654 19.9375 25.6297 19.9375C22.5404 19.9375 22.0672 22.3482 22.0672 24.8393V34.2857H16.1386V15.1964H21.8261V17.8036H21.9065C22.7011 16.3036 24.6386 14.7232 27.5226 14.7232C33.5226 14.7232 34.6386 18.6786 34.6386 23.8214V34.2857V34.2857Z",
    fill: "#8C8C94"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.5d85349f7e9d5b24e6840cb10e03f1a9.svg";
export { ForwardRef as ReactComponent };